/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { MediaType } from "@nf/common";
import { ROUTES } from "@nf/constants";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { ReactElement } from "react";

const Layout = dynamic(() => import("layouts/Layout"));

const SeriesDetailsScreen = dynamic(
  () => import("screens/SeriesDetailsScreen/SeriesDetailsScreen")
);

import styles from "screens/SeriesDetailsScreen/SeriesDetailsScreen.module.scss";

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const getCountryCookie = await import("helpers").then(
    (mod) => mod.getCountryCookie
  );
  const getLangCookie = await import("helpers").then(
    (mod) => mod.getLangCookie
  );
  const setCacheHeader = await import("helpers/cacheHeaderHelper").then(
    (mod) => mod.setCacheHeader
  );

  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );
  const { commonProps, DataProvider } = await getCommonServerSideProps(ctx);

  const cookies = ctx?.req?.headers?.cookie;
  const country = getCountryCookie(cookies);
  const language = getLangCookie(cookies);

  setCacheHeader(ctx.res);
  DataProvider.setCountry(country || `${ctx.query.country}`);

  const media = await DataProvider.getMedia({
    MediaId: `${ctx.params?.id}`,
    AssetType: MediaType.Series,
    IncludeCategories: true,
    IncludeProgress: true,
    IncludeSeasons: true,
    IncludeEpisodes: true,
    IncludeSeoData: true,
    OnlyPublished: false,
  });

  if (commonProps?.isChild && media?.ContentAdvisory) {
    return {
      redirect: {
        destination: `/${country}/${language}${ROUTES.KIDS}`,
      },
      props: {},
    };
  }

  return {
    props: {
      ...commonProps,
      media,
    },
  };
};

const SeriesDetailsScreenWrapper = (props: any) => {
  return <SeriesDetailsScreen {...props} />;
};

SeriesDetailsScreenWrapper.getLayout = function getLayout(page: ReactElement) {
  const { props } = page;
  return (
    <Layout config={props?.config} className={styles.layout}>
      {page}
    </Layout>
  );
};

export default SeriesDetailsScreenWrapper;
